import { defineConstants } from "@p-ban/common/src/constants/defineConstants"

const SEMINAR_CATEGORY = defineConstants([
  { label: "導入セミナー", value: "IntroductionSeminar" },
  { label: "技術セミナー", value: "TechnicalSeminar" },
  { label: "Quadcept講習会", value: "QuadceptTrainingSeminar" },
  { label: "Altiumセミナー", value: "AltiumSeminar" },
  { label: "DesignSpark PCB講習", value: "DesignSparkPcbTrainingSeminar" },
  { label: "CADLUS X無料体験セミナー", value: "CadlusXFreeTrialSeminar" },
] as const)

export default SEMINAR_CATEGORY
